import { render, staticRenderFns } from "./ItemUnitMeasure.vue?vue&type=template&id=8335e7e8&scoped=true"
import script from "./ItemUnitMeasure.vue?vue&type=script&lang=ts"
export * from "./ItemUnitMeasure.vue?vue&type=script&lang=ts"
import style0 from "./ItemUnitMeasure.vue?vue&type=style&index=0&id=8335e7e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8335e7e8",
  null
  
)

export default component.exports